import { render, staticRenderFns } from "./CustomTextareaImprove.vue?vue&type=template&id=da4093ee&"
import script from "./CustomTextareaImprove.vue?vue&type=script&lang=js&"
export * from "./CustomTextareaImprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
